import { render, staticRenderFns } from "./ot-settings-calendar-index.vue?vue&type=template&id=5a8dcf4b&scoped=true&"
import script from "./ot-settings-calendar-index.vue?vue&type=script&lang=ts&"
export * from "./ot-settings-calendar-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-settings-calendar-index.vue?vue&type=style&index=0&id=5a8dcf4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8dcf4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
